import styled from 'styled-components';

export const PatientDashboardView = styled.div`
  height: 100%;
  width: 100%;
  background-color: #F2F2FA;
  .header-patient-container {
    /* padding: 20px 30px 25px; */
  }
  .ainavigator-content {
    height: calc(100% - 55.44px);
    border-top: 1px #D4DFF9 solid;
    display: flex;
    position: relative;
    z-index: 200;
    width: 100%;
    position: relative;
    position: relative;
    /* padding: 0px 33px 41px 33px; */
    box-sizing: border-box;
  }
  .ainavigator-content__box {
    border-radius: 14px;
    overflow: auto;
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
  }
`